import { render } from "./RecMenuResult.vue?vue&type=template&id=6fafd2fe&scoped=true"
import script from "./RecMenuResult.vue?vue&type=script&lang=js"
export * from "./RecMenuResult.vue?vue&type=script&lang=js"

import "./RecMenuResult.vue?vue&type=style&index=0&id=6fafd2fe&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/todaymeal_front/todaymeal_front/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fafd2fe"]])

export default __exports__